import type { HttpCore } from '../http';
import type { AlertVerdict, Feedback, FeedbackRequest } from '../types';

/** `/api/v1/feedback` and the per-alert verdict. */
export function createFeedbackApi(http: HttpCore) {
  return {
    /** Free-text feedback from the portal. */
    send: (body: FeedbackRequest) => http.post<Feedback>('/feedback', body),
    /**
     * "That alert was useful / that alert was wrong." Giving a second verdict replaces the first rather than
     * counting twice.
     */
    judgeAlert: (alertId: string, verdict: AlertVerdict, message?: string) =>
      http.post<Feedback>(`/alerts/${encodeURIComponent(alertId)}/feedback`, { verdict, message }),
  };
}

export type FeedbackApi = ReturnType<typeof createFeedbackApi>;
